export interface MatchResult {
    route: string;
    params: Record<string, string>;
}

const PARAM_REGEX = /:[a-zA-Z0-9_]+/g;

export const matchRoute = (pathname: string, routePattern: string): MatchResult | null => {
    const regexPattern = routePattern
        .replace(PARAM_REGEX, '([^/]+)')
        .replace(/\//g, '\\/');

    const regex = new RegExp(`^${regexPattern}$`);
    const match = pathname.match(regex);

    if (!match) {
        return null;
    }

    const paramNames = routePattern.match(PARAM_REGEX)?.map(p => p.slice(1)) ?? [];
    const params: Record<string, string> = {};

    for (let i = 0; i < paramNames.length; i++) {
        params[paramNames[i]] = match[i + 1];
    }

    return { route: routePattern, params };
};
